var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03889 15.1472C9.83889 20.65 14.35 25.1417 19.8528 27.9611L24.1306 23.6833C24.6556 23.1583 25.4333 22.9833 26.1139 23.2167C28.2917 23.9361 30.6444 24.325 33.0556 24.325C34.125 24.325 35 25.2 35 26.2694V33.0556C35 34.125 34.125 35 33.0556 35C14.7972 35 0 20.2028 0 1.94444C0 0.875 0.875 0 1.94444 0H8.75C9.81944 0 10.6944 0.875 10.6944 1.94444C10.6944 4.375 11.0833 6.70833 11.8028 8.88611C12.0167 9.56667 11.8611 10.325 11.3167 10.8694L7.03889 15.1472Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.3f9ecd89b5ef65e33e44baf3c9286015.svg";
export { ForwardRef as ReactComponent };